import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'nombre',
    label: i18n('entities.nivelPuesto.fields.nombre'),
    schema: schemas.string(
      i18n('entities.nivelPuesto.fields.nombre'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'nivel',
    label: i18n('entities.nivelPuesto.fields.nivel'),
    schema: schemas.integer(
      i18n('entities.nivelPuesto.fields.nivel'),
      {
        "required": true
      },
    ),
  },
];